import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
import { CheckIcon, CrossIcon, FlameIcon, LockIcon, ShieldHeartIcon, SparkIcon } from './icons/Icons';
const FULL_BUNDLE_URL = 'https://rutinasimple.com//cart/52919759634713:1';
const MAIN_PRODUCT_URL = 'https://rutinasimple.com//cart/52838156763417:1';
const MAIN_PRICE = 10.99;
const TRUE_TOTAL = 37.99;
const DISCOUNTED_BUNDLE_PRICE = 29.99;
type ExitIntentUpsellProps = {
  open: boolean;
  onClose: () => void;
};
const includedItems = ['Ebook Maestro GastroSmart — protocolo de 21 días para reconstruir tu estómago.', 'Lista de Compras “Antifuego”, Desayunos Claros y Batidos de Emergencia.', 'Protocolo Jugos 7 Días — acelera la regeneración con la “Venda Líquida”.', 'Guía de Supervivencia en Restaurantes — vuelve a comer fuera sin miedo.', 'Manual SOS Anti-Crisis · Extintor Natural — alivio de emergencia para las crisis nocturnas.'];
export function ExitIntentUpsell({
  open,
  onClose
}: ExitIntentUpsellProps) {
  useEffect(() => {
    if (!open) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-99" data-mp="138hn8vktaou6">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center bg-[#111812]/75 p-3 backdrop-blur-sm sm:p-6" role="presentation" onMouseDown={event => {
      if (event.target === event.currentTarget) onClose();
    }} data-id="element-100" data-mp="1h8a8wchheeva">
          <motion.section initial={{
        opacity: 0,
        y: 24,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.97
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 25
      }} role="dialog" aria-modal="true" aria-labelledby="exit-offer-title" className="relative max-h-[94vh] w-full max-w-3xl overflow-y-auto rounded-3xl bg-[#f7f4ec] text-[#1f2a22] shadow-2xl" data-id="element-101" data-mp="1hxxmxoowvqtx">
            <button type="button" onClick={onClose} aria-label="Cerrar oferta" className="absolute right-3 top-3 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-black/20 text-white transition-colors hover:bg-black/35 focus:outline-none focus:ring-2 focus:ring-white sm:right-4 sm:top-4" data-id="element-102" data-mp="25v3971r76pp5">
              <CrossIcon className="h-5 w-5" strokeWidth={2.4} data-id="element-103" data-mp="2jl6r5gj1nx8s" />
            </button>

            <header className="rounded-t-3xl bg-[#7a1e12] px-5 py-6 text-center text-white sm:px-8 sm:py-8" data-id="element-104" data-mp="2ok1l9emgp887">
              <span className="inline-flex items-center gap-2 rounded-full bg-amber-300 px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.16em] text-[#6a190f]" data-id="element-105" data-mp="cwejwjwizl1b">
                <FlameIcon className="h-4 w-4" strokeWidth={2.2} data-id="element-106" data-mp="3ymb7ylb7bmw" />
                Última oportunidad · solo en esta pantalla
              </span>
              <div className="mx-auto mt-4 flex max-w-2xl items-start justify-center gap-3" data-id="element-107" data-mp="vp0kfhidnzs8">
                <SparkIcon className="mt-1 h-7 w-7 shrink-0 text-amber-300" strokeWidth={2.2} data-id="element-108" data-mp="rnnihiieogql" />
                <h2 id="exit-offer-title" className="font-display text-2xl font-black leading-tight sm:text-4xl" data-id="element-109" data-mp="mwynht7ip1mp">
                  Espera: no dejes tu estómago a medio proteger
                </h2>
              </div>
              <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-amber-50/90 sm:text-base" data-id="element-110" data-mp="1fekji08nxtn2">
                Antes de continuar, desbloquea el plan completo por un precio que no volverás a ver.
              </p>
            </header>

            <div className="px-5 py-6 sm:px-8 sm:py-8" data-id="element-111" data-mp="z6mopek56vlo">
              <div className="text-center" data-id="element-112" data-mp="z40flahls81c">
                <span className="animate-discount-flash inline-flex items-center gap-2 rounded-full bg-[#e0611f] px-4 py-2 font-display text-sm font-black uppercase tracking-wide text-white shadow-lg" data-id="element-113" data-mp="l6vi3yvyghhp">
                  <ShieldHeartIcon className="h-5 w-5" strokeWidth={2.2} data-id="element-114" data-mp="1dur7eij7374g" />
                  Casi 30% de descuento en los 3 complementos
                </span>
                <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-[#3d4a40] sm:text-lg" data-id="element-115" data-mp="1hyfi3a34iitx">
                  No solo apagues el fuego de hoy: regenera la mucosa, vuelve a comer fuera sin miedo y ten un extintor natural listo para cualquier crisis. Completa GastroSmart con los tres protocolos que aceleran tu recuperación y protegen tu libertad social.
                </p>
                <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-[#5a6b5c]" data-id="element-116" data-mp="21moj89mn9z5k">
                  Recibes el ebook maestro, sus tres bonos y los protocolos de jugos, restaurantes y emergencias en un solo paquete.
                </p>
              </div>

              <div className="mt-6 rounded-2xl border border-[#3f6b3a]/15 bg-white p-4 sm:p-5" data-id="element-117" data-mp="2knvr94bk2ayo">
                <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#3f6b3a]" data-id="element-118" data-mp="2fr5fgt6sa1j2">
                  Todo lo que incluye tu paquete completo
                </p>
                <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-119" data-mp="1nzg0x60mfxki">
                  {includedItems.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-[#3d4a40]" data-id="element-120" data-mp="21yz6ps5ymwtn">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#3f6b3a] text-white" data-id="element-121" data-mp="1wyupu115402w">
                        <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-122" data-mp="3dfywag0xaxjz" />
                      </span>
                      <span data-id="element-123" data-mp="38h5kcs1abelx">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-6 rounded-2xl bg-[#1f2a22] p-5 text-center text-white sm:p-6" data-id="element-124" data-mp="3kgsrac3k2b7w">
                <div className="flex items-center justify-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-[#9bd492]" data-id="element-125" data-mp="3pgf5anr7jvhr">
                  <LockIcon className="h-4 w-4" strokeWidth={2.2} data-id="element-126" data-mp="3udxgylwm0otg" />
                  Pago seguro · precio especial solo disponible en esta pantalla
                </div>
                <div className="mt-4 flex items-end justify-center gap-4" data-id="element-127" data-mp="31q1mlnuij8zu">
                  <div data-id="element-128" data-mp="36pnxvrqs6f60">
                    <p className="text-xs text-white/50" data-id="element-129" data-mp="36p5wkgp9har8">Precio normal</p>
                    <p className="font-display text-xl font-bold text-white/50 line-through" data-id="element-130" data-mp="3bge231nh0bz4">
                      ${TRUE_TOTAL.toFixed(2)}
                    </p>
                  </div>
                  <div data-id="element-131" data-mp="2dz5x4xdj4pvr">
                    <p className="text-xs font-semibold uppercase tracking-wide text-amber-300" data-id="element-132" data-mp="2iztjv6uq6kk6">
                      Paquete completo
                    </p>
                    <p className="font-display text-5xl font-black text-[#9bd492]" data-id="element-133" data-mp="2bfsq6yy2oak5">
                      ${DISCOUNTED_BUNDLE_PRICE.toFixed(2)}
                    </p>
                  </div>
                </div>
                <p className="mt-2 text-xs text-white/55" data-id="element-134" data-mp="21k7kappvuq54">
                  GastroSmart ${MAIN_PRICE.toFixed(2)} + los 3 complementos con precio especial
                </p>
              </div>

              <div className="mt-6 space-y-3" data-id="element-135" data-mp="1sjsupe5vyovt">
                <motion.a href={FULL_BUNDLE_URL} onClick={() => trackAddToCart(DISCOUNTED_BUNDLE_PRICE)} whileHover={{
              scale: 1.01
            }} whileTap={{
              scale: 0.98
            }} animate={{
              boxShadow: ['0 10px 28px -8px rgba(224,97,31,0.45)', '0 16px 42px -6px rgba(224,97,31,0.75)', '0 10px 28px -8px rgba(224,97,31,0.45)']
            }} transition={{
              duration: 1.8,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="flex w-full items-center justify-center gap-2 rounded-2xl bg-[#e0611f] px-5 py-4 text-center font-display text-sm font-black uppercase tracking-wide text-white sm:text-base" data-id="element-136" data-mp="1nqpyszdmz3cg">
                  <CheckIcon className="h-5 w-5 shrink-0" strokeWidth={3} data-id="element-137" data-mp="2nnvyt07y0vnw" />
                  Sí, quiero el paquete completo por ${DISCOUNTED_BUNDLE_PRICE.toFixed(2)}
                </motion.a>

                <a href={MAIN_PRODUCT_URL} onClick={() => trackAddToCart(MAIN_PRICE)} className="block w-full rounded-xl px-4 py-3 text-center text-sm font-semibold text-[#5a6b5c] underline decoration-[#5a6b5c]/35 underline-offset-4 transition-colors hover:text-[#1f2a22]" data-id="element-138" data-mp="2eqlopi6v3ckk">
                  No gracias, continuar sin los extras →
                </a>
              </div>
            </div>
          </motion.section>
        </motion.div>}
    </AnimatePresence>;
}